import $ from 'jquery';

export default () => {
  $('.block-system .view-search input[name="search"]').first().focus();

  $(document).on('popup.opened', function(e, popup) {
    if (popup.hasClass('search')) {
      popup.find('.view-search input[name="search"]').first().focus();
    }
  });
}
